import React from 'react';

import ToggleExpandButton from 'ui-library/buttons/ToggleExpandButton';

import {PrimaryActionRenderFn} from '../DataFrameActionToolbar';

export function createRenderExpandTableButton(
  isExpandedPreviewState: boolean,
  setIsExpandedPreviewState: (newState: boolean) => void
): PrimaryActionRenderFn {
  return () => (
    <ToggleExpandButton
      isExpanded={isExpandedPreviewState}
      onChange={setIsExpandedPreviewState}
      className="u-mini-spacing-left"
      key="ToggleExpandButton"
      dataTestAttrs={{
        component: 'DataFrameTableWrapper',
        element: isExpandedPreviewState ? 'collapsePreviewTableButton' : 'expandPreviewTableButton',
      }}
    />
  );
}
